var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StandardLayout',[_c('v-sheet',{staticClass:"mx-12 my-6",attrs:{"slot":"main","rounded":""},slot:"main"},[_c('h1',{staticClass:"outfit-regular"},[_vm._v("Guild")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }